export const COMPUTER_ID: string = 'astrea-computer-id';
